
import React from 'react';
import { AgeGroup } from '@/types/user';

interface AgeBasedNoticesProps {
  userAgeGroup: AgeGroup;
}

const AgeBasedNotices: React.FC<AgeBasedNoticesProps> = ({ userAgeGroup }) => {
  if (userAgeGroup === '18-plus') {
    return null;
  }

  if (userAgeGroup === '13-and-under') {
    return (
      <div className="bg-blue-900/20 border border-blue-500 rounded-lg p-4">
        <h4 className="text-blue-400 font-medium mb-2">👶 Safe Space for Young Athletes</h4>
        <p className="text-blue-300 text-sm">
          Your account has special protections in place. Some features are limited to ensure a safe experience.
          If you need access to additional features, please have a parent or guardian contact support.
        </p>
      </div>
    );
  }

  if (userAgeGroup === '14-17') {
    return (
      <div className="bg-orange-900/20 border border-orange-500 rounded-lg p-4">
        <h4 className="text-orange-400 font-medium mb-2">🏃‍♂️ Teen Athlete Account</h4>
        <p className="text-orange-300 text-sm">
          Most features are available to you! Some business-related features require you to be 18+ or have special approval.
        </p>
      </div>
    );
  }

  return null;
};

export default AgeBasedNotices;
